<template>
  <div>
    <TopScorerInTeam></TopScorerInTeam>
  </div>
</template>

<script>
import TopScorerInTeam from "@/components/news/TopScorerInTeam.vue";

export default {
  name: "TopScorerInTeamView",
  components: {
    TopScorerInTeam
  }
};
</script>

<style></style>
